import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import './react-lightbox-component-custom.css';
import 'font-awesome/css/font-awesome.min.css';
import registerServiceWorker from './registerServiceWorker';
import App from './App';


ReactDOM.render(
  <App />,
  document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js